import { useOidc } from '@axa-fr/react-oidc';
import type { AuthorizationRoles, MarketRole } from '#pie/internal/api/pie-bff';
import { useGetUserOrganisationInformation } from '#pie/internal/api/pie-bff';
import { hasRole } from '#pie/internal/libs/auth';
import { useCurrentOrganisation } from '.';

export const useUserHasRole = ({
  role,
  marketRole,
}: {
  role?: AuthorizationRoles;
  marketRole?: MarketRole | MarketRole[];
}): undefined | boolean => {
  const { isAuthenticated } = useOidc();
  const { isLoading } = useGetUserOrganisationInformation({
    query: { enabled: isAuthenticated },
  });
  const { currentAccount } = useCurrentOrganisation();

  if (isLoading) return undefined;

  if (!isAuthenticated || !currentAccount) {
    return false;
  }

  const hasRequiredRole = !role || hasRole(role, currentAccount.roles);
  const hasRequiredMarketRole =
    !marketRole || hasRole(marketRole, [currentAccount.marketRole]);

  return hasRequiredRole && hasRequiredMarketRole;
};
